import axios from 'axios';
import { getAuth } from 'firebase/auth';

const loadExternalTasks = (accountId, inputValue) => {
  if (!accountId) return;

  return new Promise(async (resolve, reject) => {
    const auth = getAuth();
    const user = auth.currentUser;
    const firebaseToken = await user.getIdToken();

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/taskSearch?accountId=${accountId}&search=${inputValue}`,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
        },
      },
    );

    data?.tasks?.sort(({ label: firstLabel }, { label: secondLabel }) => {
      const normalizedA = firstLabel
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      const normalizedB = secondLabel
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

      return normalizedA > normalizedB ? 1 : normalizedB > normalizedA ? -1 : 0;
    });

    resolve(data?.tasks);
  });
};

export { loadExternalTasks };
